"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonCheck = exports.isReserveMet = exports.getNewDateWithOffset = void 0;
var getNewDateWithOffset = function (millisecondsOffset) {
    var currentDate = new Date();
    var offsetDate = new Date(currentDate.getTime() + millisecondsOffset);
    return offsetDate;
};
exports.getNewDateWithOffset = getNewDateWithOffset;
var isReserveMet = function (_a) {
    var overrideWinningBidAmount = _a.overrideWinningBidAmount, reservePrice = _a.reservePrice, winningRegisteredProfileAmount = _a.winningRegisteredProfileAmount, topBid = _a.topBid;
    if (reservePrice === undefined || reservePrice === null)
        return false;
    var reserve = reservePrice ? Number(reservePrice) : 0;
    if (reserve === 0)
        return true;
    var highestBid = topBid ? Number(topBid) : overrideWinningBidAmount ? Number(overrideWinningBidAmount) : winningRegisteredProfileAmount ? Number(winningRegisteredProfileAmount) : 0;
    return highestBid >= reserve;
};
exports.isReserveMet = isReserveMet;
var JsonCheck = function (value) {
    if (typeof value === "string") {
        try {
            return JSON.parse(value);
        }
        catch (error) {
            console.error("Error: Unable to deserialize the string");
            return null;
        }
    }
    else {
        return value;
    }
};
exports.JsonCheck = JsonCheck;
